<template>
    <div :class="['miniliink', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
        <div class="miniliink-box">
            <img v-if="img" class="pxind" :src="img" alt="" />
            <button v-if="apiId" @click="gostudy">前往小程序</button>
        </div>
    </div>
</template>

<script>
import { miniSchemeUrl } from '@/utils/common';
import { reqMiniProgramJump } from '@/api/home'

export default {
    data() {
        return {
            code: '',
            img: '',
            apiId: '',
            path: '',
            query: ''
        };
    },
    created() {
        const { code } = this.$route.params;
        this.code = code;
        this.fetchData(code);
    },
    methods: {
        async fetchData(code) {
            const res = await reqMiniProgramJump(code)
            const data = res.data
            this.img = data.iconUrl;
            this.apiId = data.apiId;
            const [path, query] = data.pagePath.trim().split('?');
            // 如果 path 没有以 / 开头，则添加一个 /
            this.path = path.startsWith('/') ? path : '/' + path;
            this.query = `${query ? `${query}&` : ''}bookName=${encodeURIComponent(data.bookName)}&fromUrl=${encodeURIComponent(window.location.href)}&isMiniRedict=1`;
            if (!this.apiId) return;
            // 自动前往小程序
            this.gostudy(this.apiId, this.path, this.query)
        },
        async gostudy() {
            const schemeLink = await miniSchemeUrl(this.apiId, this.path, this.query)
            console.log(4444, this.apiId, this.path, this.query,)
            if (schemeLink) {
                window.location.href = schemeLink;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.inApp {
    padding-top: 20px !important;
}

.miniliink {
    width: 100%;
    height: 100vh;
    // padding-top: 101px;
    // padding-bottom: 210px;
    background: #f9f9f9;
    user-select: none;

    .miniliink-box {
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    button {
        display: block;
        width: 260px;
        height: 70px;
        color: #fff;
        font-weight: 500;
        font-size: 32px;
        line-height: 70px;
        background: #ff6c02;
        border-radius: 45px;
        margin: 200px auto 0;
    }

    .pxind {
        display: block;
        margin: 0 auto;
        width: 200px;
        // height: 200px;
        border-radius: 50%;
    }
}
</style>
